<div class="container">
  <div class="d-none d-lg-block pt-3">
    <div class="back-button" [routerLink]="'/rewards'">
      <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
    </div>
  </div>
</div>

<!-- Points Summary -->
<div class="container d-lg-none d-block">
  <fgb-points-summary-bar></fgb-points-summary-bar>
</div>

<div class="mt-lg-2">
  <fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
</div>
